export * from 'react-icons/fa'
export * from 'react-icons/bi'
export * from 'react-icons/ai'
export * from 'react-icons/io'
export * from 'react-icons/bs'
export * from 'react-icons/md'
export * from 'react-icons/fi'

